export default __webpack_public_path__ + "static/media/ninja.2a9fcfc1.glb";